import $ from 'jquery';

export function verticallyScrollItemIntoView(scrollArea: Element, scrollItem: Element): void {
  let offsetTop;
  const scrollAreaBox = scrollArea.getBoundingClientRect();
  const itemBox = scrollItem.getBoundingClientRect();

  if (itemBox.top < scrollAreaBox.top) {
    offsetTop = itemBox.top - scrollAreaBox.top;
  } else if (itemBox.bottom > scrollAreaBox.bottom) {
    offsetTop = itemBox.bottom - scrollAreaBox.bottom;
  } else {
    // Item is already visible
    return;
  }

  $(scrollArea)
    .stop()
    .animate({scrollTop: scrollArea.scrollTop + offsetTop}, {duration: 150});
}
